import type { ContentMedia, ContentMediaResponsiveFormats, ContentBackgroundImage, ContentBackgroundImageMobile } from '@nimbus/types'

export const useContentMedia = () => {
    const getContentMediaUrl = (relativeUrl?: string) => {
        if (!relativeUrl) return undefined

        return relativeUrl
    }

    const getContentMediaAttr = (mediaObj: ContentMedia | ContentBackgroundImage | ContentBackgroundImageMobile, responsiveSize?: ContentMediaResponsiveFormats) => {
        if (!mediaObj) {
            return null
        }

        // If media has responsive sizes, return the requested sizes attributes
        const formats = mediaObj.formats as Record<string, unknown> | undefined
        if (responsiveSize && formats?.[responsiveSize]) {
            return formats[responsiveSize] as typeof mediaObj
        }

        return mediaObj
    }

    return {
        getContentMediaAttr,
        getContentMediaUrl,
    }
}
